import { h, Fragment } from "preact";
import { useState, useEffect } from "preact/hooks";
import { positions } from "./constants";
import fontFaceName from "./font-face-name";

const parsePosition = (position) => {
  const match = /(?<top>[\d.]+)\D+(?<left>[\d.]+)/gm.exec(position);

  if (!match) {
    return { top: 0, left: 0 };
  }

  return { top: `${match.groups.top}%`, left: `${match.groups.left}%` };
};

const parseFontSize = (size) => {
  if (!size) return 1;

  return parseFloat(size) / 100;
};

const findColor = (color, availableColors) => {
  const matchingColor = availableColors.find(({ label }) => color === label);

  return matchingColor?.color || "#000";
};

export default function MonogramPreview({
  product,
  globalConfig,
  config,
  className,
}) {
  let imageUrl =
    product.topImage?.previewImage.url || product.media[0].previewImage.url;

  const sidePositionAvailable = product.monogramSettings.sidePosition !== null;
  const isSide = config.position === positions.side;
  if (sidePositionAvailable) {
    if (isSide) {
      imageUrl =
        product.sideImage?.previewImage.url ||
        product.media[0].previewImage.url;
    } else {
      imageUrl =
        product.topImage?.previewImage.url || product.media[1].previewImage.url;
    }
  }

  let initialsPosition1 = "";
  let initialsPosition2 = "";

  if (isSide || product.monogramSettings.mainPosition2 === null) {
    initialsPosition1 = config.initials || "";
  } else {
    initialsPosition1 = config.initials?.[0] || "";
    initialsPosition2 = config.initials?.[1] || "";
  }

  const fontFactors = {
    small: parseFontSize(product.monogramSettings.smallFontSize),
    medium: parseFontSize(product.monogramSettings.mediumFontSize),
    large: parseFontSize(product.monogramSettings.largeFontSize),
  };

  const sideFactor = isSide ? 0.65 : 1;

  const styles = {
    "--monogram-font-factor": (fontFactors[config.size] || 1) * sideFactor,
    "--monogram-font-color": findColor(config.color, globalConfig.colors),
    "--monogram-font-shadow-color": findColor(
      config.shadowColor,
      globalConfig.shadowColors,
    ),
    "--monogram-font-family": `"${fontFaceName(config.font?.name)}"`,
  };

  const initialsClass = `
    monogram-config__preview-initials
    monogram-config__preview-initials--${config.size}
    ${config.font?.hasShadow === "true" ? "monogram-config__preview-initials--shadow" : ""}
  `;

  return (
    <div className={`monogram-config__preview-wrapper ${className}`}>
      <div className="monogram-config__preview" style={styles}>
        <img
          className="monogram-config__preview-image"
          src={window.getSizedImageUrl(imageUrl, "x3000")}
          alt=""
        />
        <div
          className={initialsClass}
          style={parsePosition(
            isSide
              ? product.monogramSettings.sidePosition
              : product.monogramSettings.mainPosition1,
          )}
        >
          {initialsPosition1}
        </div>
        <div
          className={initialsClass}
          style={parsePosition(product.monogramSettings.mainPosition2)}
        >
          {initialsPosition2}
        </div>
      </div>
    </div>
  );
}
